import { API_BASE_URL } from '../../../api/prospects';

/** URL absolue pour un média stocké sous /web-creator/sites/…/media/… */
export function resolveWebCreatorMediaUrl(stored) {
  const raw = String(stored || '').trim();
  if (!raw) return '';
  if (/^https?:\/\//i.test(raw) || raw.startsWith('blob:')) return raw;
  if (raw.startsWith('data:')) return raw;
  const base = (API_BASE_URL || '').replace(/\/$/, '');
  if (raw.startsWith('/web-creator/')) {
    return `${base}${raw}`;
  }
  if (raw.startsWith('web-creator/')) {
    return `${base}/${raw}`;
  }
  return raw;
}

export function isInlineWebCreatorMedia(stored) {
  return String(stored || '').trim().startsWith('data:');
}
